export default __webpack_public_path__ + "static/media/a6.9a5e770b.png";